import { useLocation, useNavigate } from 'react-router-dom';
import { buscarPontosDeMototaxiProximos } from '../servicos/listagemServico';
import { MapContainer, TileLayer, Marker, Popup, useMap, Polyline } from 'react-leaflet';
import { useEffect, useState } from 'react';
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import Cookies from 'js-cookie';
import { aplicarMascaraTelefone } from '../uteis/mascaras/mascaraTelefone';
import LoadingIndicator from '../components/LoadingIndicator';
import InputEndereco from '../components/InputEndereco';
import { buscarEndereco, buscarEnderecoPorCoordenada } from "../servicos/geocodingServico"; // google

function MapaAtual() {
  const [loadingIndicator, setLoadingIndicator] = useState(true);
  const [mostrarModalLocalidades, setMostrarModalLocalidades] = useState(false);
  const [localidadesAtendidasSelecionadas, setLocalidadesAtendidasSelecionadas] = useState([]);
  const navigate = useNavigate();
  const [posicaoEnderecoOrigem, setPosicaoEnderecoOrigem] = useState(null);
  const [posicaoEnderecoDestino, setPosicaoEnderecoDestino] = useState(null);

  function AjustarBounds({ posicao, posicaoDestino }) {
    const map = useMap();
    useEffect(() => {
      if (posicao && posicaoDestino) {
        const bounds = L.latLngBounds([posicao, posicaoDestino]);
        map.fitBounds(bounds, { padding: [50, 50] });
      } else if (posicao) {
        map.setView(posicao, 17);
      }
    }, [posicao, posicaoDestino, map]);
    return null;
  }

  useEffect(() => {
    console.log('Removendo dadosCookies ao entrar no MapaAtual.js...');
    Cookies.remove('dadosCookies');
  }, []);

  const BASE_URL =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://127.0.0.1:8000' 
      : 'https://mercadinhointeligente.com.br';

  const [posicao, setPosicao] = useState(null);
  const [pontosProximos, setPontosProximos] = useState([]);
  const location = useLocation();
  const servicoSelecionado = location.state?.servicoSelecionado || null;

  const cookies = Cookies.get();
  const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

  const [mostrarModal, setMostrarModal] = useState(false);
  const [pontoSelecionado, setPontoSelecionado] = useState(null);

  const [telefone, setTelefone] = useState('');
  const [enderecoOrigem, setEnderecoOrigem] = useState('');
  const [enderecoDestino, setEnderecoDestino] = useState('');

  const iconeDestino = new L.DivIcon({
    html: `
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="red" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
        <circle cx="12" cy="9" r="2" fill="white"/>
      </svg>
    `,
    className: '',
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
  });

  const iconeUsuario = new L.Icon({
    iconUrl: '/imagens/icones/boneco1.png',
    iconSize: [65, 65],
  });

  const iconeOrigem = new L.Icon({
    iconUrl: '/imagens/icones/boneco1.png',
    iconSize: [50, 50],
  });

  useEffect(() => {
    if (posicao && !posicaoEnderecoOrigem) {
      setPosicaoEnderecoOrigem(posicao);
      buscarEnderecoPorCoordenada(posicao[0], posicao[1]).then(resultado => {
        if (resultado) setEnderecoOrigem(resultado.endereco);
      });
    }
  }, [posicao]);

  const atualizarDadosDestinoNosCookies = (lat, lng) => {
    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : {};

    const novosDadosInternauta = {
      ...dadosCookies.dadosInternauta,
      latitudeDestino: lat,
      longitudeDestino: lng,
      descricao_endereco_destino: enderecoDestino
    };

    const novosDadosCookies = {
      ...dadosCookies,
      dadosInternauta: novosDadosInternauta
    };

    Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 7 });
    console.log('Destino atualizado nos cookies:', novosDadosInternauta);
  };

  useEffect(() => {
    if (posicaoEnderecoDestino) {
      atualizarDadosDestinoNosCookies(posicaoEnderecoDestino[0], posicaoEnderecoDestino[1]);
    }
  }, [posicaoEnderecoDestino]);

  // Substituindo fetch por serviço
  const buscarEnderecoDestinoPorCoordenadas = async (lat, lng) => {
    try {
      const resultado = await buscarEnderecoPorCoordenada(lat, lng);
      return resultado?.endereco || '';
    } catch (err) {
      console.error("Erro ao buscar endereço do destino:", err);
      return '';
    }
  };

  const buscarEnderecoPorCoordenadas = async (lat, lng) => {
    try {
      const resultado = await buscarEnderecoPorCoordenada(lat, lng);
      if (resultado) {
        setEnderecoOrigem(resultado.endereco);
      }
    } catch (err) {
      console.error("Erro ao buscar endereço:", err);
    }
  };

  const buscarCoordenadasDestino = async (endereco) => {
    if (!endereco) return;
    try {
      const resultado = await buscarEndereco(endereco);
      if (resultado) {
        setPosicaoEnderecoDestino([resultado.lat, resultado.lng]);
      } else {
        alert("Endereço de destino não encontrado!");
      }
    } catch (err) {
      console.error("Erro ao buscar coordenadas do destino:", err);
    }
  };

  const buscarCoordenadasPorEndereco = async (endereco) => {
    if (!endereco) return;
    try {
      const resultado = await buscarEndereco(endereco);
      if (resultado) {
        setPosicaoEnderecoOrigem([resultado.lat, resultado.lng]);
      } else {
        alert("Endereço não encontrado!");
      }
    } catch (err) {
      console.error("Erro ao buscar coordenadas:", err);
    }
  };

  const abrirModalLocalidades = (localidades) => {
    setLocalidadesAtendidasSelecionadas(localidades || []);
    setMostrarModalLocalidades(true);
  };


useEffect(() => {
  if (!navigator.geolocation) {
    alert("Geolocalização não é suportada pelo seu navegador.");
    return;
  }

  const options = {
    enableHighAccuracy: true, // força usar GPS/Wi-Fi
    timeout: 10000,           // espera até 10s
    maximumAge: 0             // não usa cache
  };

  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const coords = [pos.coords.latitude, pos.coords.longitude];
      console.log("Localização obtida:", coords);
      setPosicao(coords);
    },
    (err) => {
      console.error("Erro ao obter localização:", err);

      switch (err.code) {
        case err.PERMISSION_DENIED:
          alert("Permissão de localização negada. Habilite no navegador/macOS.");
          break;
        case err.POSITION_UNAVAILABLE:
          alert("A localização não está disponível. Verifique Wi-Fi ou VPN.");
          break;
        case err.TIMEOUT:
          alert("Tempo esgotado para obter localização.");
          break;
        default:
          alert("Erro desconhecido ao obter localização.");
      }

      navigate("/");
    },
    options
  );
}, []);




  // useEffect(() => {
  //   navigator.geolocation.getCurrentPosition(
  //     (pos) => {
  //       const coords = [pos.coords.latitude, pos.coords.longitude];
  //       setPosicao(coords);
  //     },
  //     (err) => {
  //       console.error('Erro ao obter localização:', err);
  //       alert('Não foi possível obter a sua localização. Tente novamente.');
  //       navigate('/');
  //     }
  //   );
  // }, []);

  useEffect(() => {
    const carregarPontos = async () => {
      setLoadingIndicator(true);
      if (posicao) {
        try {
          const dados = {
            latitude: posicao[0],
            longitude: posicao[1],
            servico_id: servicoSelecionado?.id ?? null
          };

          const dadosInternauta = { dadosInternauta: dados };
          const novosDadosCookies = { ...dadosCookies, ...dadosInternauta };
          Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 7 });

          const resposta = await buscarPontosDeMototaxiProximos(dados);
          setPontosProximos(resposta.dados);
        } catch (error) {
          console.error('Erro ao buscar pontos próximos:', error);
        } finally {
          setLoadingIndicator(false);
        }
      }
    };
    carregarPontos();
  }, [posicao, servicoSelecionado]);

  if (!posicao) {
    return <p>Obtendo localização...</p>;
  }

  const abrirModal = (pontoId) => {
    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;
    const dadosInternauta = dadosCookies?.dadosInternauta || {};

    if (dadosInternauta.numero_celular_com_ddd) setTelefone(dadosInternauta.numero_celular_com_ddd);
    if (dadosInternauta.descricao_endereco_origem) setEnderecoOrigem(dadosInternauta.descricao_endereco_origem);
    if (dadosInternauta.descricao_endereco_destino) setEnderecoDestino(dadosInternauta.descricao_endereco_destino);

    setPontoSelecionado(pontoId);
    setMostrarModal(true);
    if (posicao) setPosicaoEnderecoOrigem(posicao);
  };

  const salvarDadosInternauta = () => {
    if (!telefone || !enderecoOrigem) {
      alert('Por favor, preencha o telefone e a origem.');
      return;
    }
    setLoadingIndicator(true);

    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : {};

    const novosDadosInternauta = {
      ...dadosCookies.dadosInternauta,
      numero_celular_com_ddd: telefone,
      descricao_endereco_origem: enderecoOrigem,
      descricao_endereco_destino: enderecoDestino || null
    };

    const novosDadosCookies = { ...dadosCookies, dadosInternauta: novosDadosInternauta };
    Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 7 });

    setMostrarModal(false);
    setLoadingIndicator(false);
    window.location.href = `/solicitar-servico/${pontoSelecionado}`;
  };

  if (loadingIndicator) {
    return <LoadingIndicator fullscreen message="Aguarde..." />;
  }




  return (
    <>
      

{mostrarModalLocalidades && (

<div
  className="modal fade show d-block"
  tabIndex="-1"
  role="dialog"
  style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
>
  <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div className="modal-content shadow-lg border-0 rounded-4">
      {/* Cabeçalho */}
      <div className="modal-header bg-primary text-white rounded-top-4">
        <h5 className="modal-title fw-bold">
          <i className="bi bi-geo-alt-fill me-2"></i> Localidades Atendidas
        </h5>
        <button
          type="button"
          className="btn-close btn-close-white"
          onClick={() => setMostrarModalLocalidades(false)}
        ></button>
      </div>

      {/* Corpo */}
      <div className="modal-body p-4">
        {localidadesAtendidasSelecionadas.length === 0 ? (
          <p className="text-muted text-center">
            <i className="bi bi-info-circle me-2"></i>
            Nenhuma localidade registrada.
          </p>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover align-middle text-center">
              <thead className="table-primary">
                <tr>
                  <th>Nome</th>
                  <th>Valor <br /><small>(06h às 23h)</small></th>
                  <th>Valor <br /><small>(23h às 06h)</small></th>
                </tr>
              </thead>
              <tbody>
                {localidadesAtendidasSelecionadas.map((loc, index) => (
                  <tr key={index}>
                    <td className="fw-semibold text-start">
                      <i className="bi bi-geo me-2 text-primary"></i>
                      {loc.nome} - {loc.cidade}/{loc.uf}
                    </td>
                    <td className="text-success fw-bold">
                      R$ {parseFloat(loc.valor_6_as_23).toFixed(2)}
                    </td>
                    <td className="text-danger fw-bold">
                      R$ {parseFloat(loc.valor_23_as_6).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Rodapé */}
      <div className="modal-footer border-0">
        <button
          type="button"
          className="btn btn-secondary px-4"
          onClick={() => setMostrarModalLocalidades(false)}
        >
          <i className="bi bi-x-circle me-2"></i> Fechar
        </button>
      </div>
    </div>
  </div>
</div>


  )}



{mostrarModal && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div className="modal-content shadow-lg border-0">
        <div className="modal-header border-0">
          <div>
            <h5 className="modal-title fw-bold">Informe seus dados</h5>
            <small className="text-muted">Assim o piloto te localiza mais rápido</small>
          </div>
          <button
            type="button"
            className="btn-close"
            onClick={() => setMostrarModal(false)}
          ></button>
        </div>

        <div className="modal-body">
          {/* Telefone */}
          <div className="mb-3">
            <label htmlFor="telefone" className="form-label">
              Seu celular <span className="text-danger">*</span>
            </label>
            <input
              type="tel"
              id="telefone"
              className="form-control"
              value={telefone}
              onChange={(e) => setTelefone(aplicarMascaraTelefone(e.target.value))}
              placeholder="(XX) XXXXX-XXXX"
            />
          </div>

          {/* Endereço Origem */}
          <div className="mb-3 row">
            <div className="col-9">

              <InputEndereco
                label="Endereço onde você está agora"
                endereco={enderecoOrigem}
                setEndereco={setEnderecoOrigem}
                setPosicao={setPosicaoEnderecoOrigem}
              />
            </div>
            <div className="col-3 d-flex align-items-end">

              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => buscarCoordenadasPorEndereco(enderecoOrigem)}
              >
                Atualizar mapa
              </button>
            </div>
          </div>

          {/* Endereço Destino */}
          <div className="mb-3 row">
            <div className="col-9">

              <InputEndereco
                label="Endereço de destino"
                endereco={enderecoDestino}
                setEndereco={setEnderecoDestino}
                setPosicao={setPosicaoEnderecoDestino}
              />
            </div>
            <div className="col-3 d-flex align-items-end">

              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => buscarCoordenadasDestino(enderecoDestino)}
              >
                Atualizar mapa
              </button>
            </div>
          </div>

          {/* Mini-mapa dentro do modal */}
          {posicaoEnderecoOrigem && (
            <div style={{ height: "300px", marginTop: "20px" }}>
              <MapContainer
                center={posicaoEnderecoOrigem}
                zoom={17}
                style={{ height: "100%", width: "100%" }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="© OpenStreetMap contributors"
                />

                {/* Ajustar bounds se destino estiver definido */}
                <AjustarBounds
                  posicao={posicaoEnderecoOrigem}
                  posicaoDestino={posicaoEnderecoDestino}
                />

                {/* Marcador de origem (arrastável) */}
                <Marker
                  position={posicaoEnderecoOrigem}
                  icon={iconeOrigem}
                  draggable={true}
                  eventHandlers={{
                    dragend: (e) => {
                      const { lat, lng } = e.target.getLatLng();
                      setPosicaoEnderecoOrigem([lat, lng]);
                      buscarEnderecoPorCoordenadas(lat, lng);
                    },
                  }}
                >
                  <Popup>Arraste o boneco para a sua localização</Popup>
                </Marker>

                {/* Marcador de destino, se definido */}
{posicaoEnderecoDestino && (
  <Marker
    position={posicaoEnderecoDestino}
    icon={iconeDestino}
    draggable={true} // permite arrastar
    eventHandlers={{
      dragend: (e) => {
        const { lat, lng } = e.target.getLatLng();
        setPosicaoEnderecoDestino([lat, lng]); // atualiza estado
        // atualiza endereço do destino
        buscarEnderecoDestinoPorCoordenadas(lat, lng)
          .then((novoEndereco) => setEnderecoDestino(novoEndereco))
          .catch((err) => console.error('Erro ao atualizar endereço do destino:', err));
      },
    }}
  >
    <Popup>Destino: {enderecoDestino}</Popup>
  </Marker>
)}

              </MapContainer>
            </div>
          )}
        </div>

        <div className="modal-footer border-0">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setMostrarModal(false)}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={salvarDadosInternauta}
          >
            Salvar e continuar
          </button>
        </div>
      </div>
    </div>
  </div>
)}




      <div style={{ height: 'calc(100vh - 110px)' }}>
        <MapContainer center={posicao} zoom={14.2} style={{ flex: 1, height: '100%', width: '100%' }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="© OpenStreetMap contributors"
          />

          <AjustarBounds posicao={posicao} posicaoDestino={posicaoEnderecoDestino} />
  
          <Marker position={posicao} icon={iconeUsuario}>
            <Popup><h2>Você está aqui</h2></Popup>
          </Marker>

          {posicaoEnderecoDestino && (
            <Marker
              position={posicaoEnderecoDestino}
              icon={iconeDestino}
              draggable={true}
              eventHandlers={{
                dragend: (e) => {
                  const { lat, lng } = e.target.getLatLng();
                  setPosicaoEnderecoDestino([lat, lng]);
                  buscarEnderecoDestinoPorCoordenadas(lat, lng)
                    .then((novoEndereco) => setEnderecoDestino(novoEndereco))
                    .catch((err) => console.error('Erro ao atualizar endereço do destino:', err));
                },
              }}
            >
              <Popup>
                <h2>Destino</h2>
                <p>{enderecoDestino}</p>
              </Popup>
            </Marker>
          )}


          {pontosProximos.map((ponto) => {
            const imagemLogomarca = `${BASE_URL}/storage/imagens/pontoMotoTaxi/logomarca_ponto_mototaxi_${ponto.id}.png`;

            console.log('ponto: ');
            console.log(ponto);

            console.log('localidades atendidas: ');
            console.log(ponto.localidadesAtendidas);

            const iconeCustomizado = imagemLogomarca
              ? new L.DivIcon({
                html: `
                  <div style="
                  width: 65px;
                  height: 55px;
                  border: 2px solid black;
                  border-radius: 6px;
                  overflow: hidden;
                  box-shadow: 0 0 4px rgba(0,0,0,0.4);
                  ">
                  <img src="${imagemLogomarca}" style="
                      width: 100%;
                      height: 100%;
                      object-fit: contain;
                      display: block;
                  " />
                  </div>
                `,
                iconSize: [42, 42],
                iconAnchor: [21, 42],
                popupAnchor: [0, -42],
                className: ''
              })
              : iconeDestino;

            return (
              <Marker
                key={ponto.id}
                position={[ponto.latitude, ponto.longitude]}
                icon={iconeCustomizado}
              >
                <Popup>
                  <div style={{ textAlign: 'center' }}>
                    <strong>{ponto.nome_ponto}</strong><br />
                    {ponto.endereco}<br />

                    {imagemLogomarca && (
                      <img
                        src={imagemLogomarca}
                        alt="Logomarca"
                        style={{
                          width: '100px',
                          height: '100px',
                          objectFit: 'contain',
                          margin: '8px auto',
                          borderRadius: '6px',
                          border: '4px solid black'
                        }}
                      />
                    )}
                    
                    
                    {
                      servicoSelecionado?.nome === 'Moto Taxi' || servicoSelecionado?.nome === 'Mototáxi' || servicoSelecionado?.nome === 'Encomendas Pequenas'
                      ?
                      <>
                        <hr />
                        <button
                          type="button"
                          className="btn btn-info me-auto"
                          onClick={() => {
                            // const ponto = pontosProximos.find(p => p.id === pontoSelecionado);
                            abrirModalLocalidades(ponto?.localidadesAtendidas || []);
                          }}
                        >
                          Localidades atendidas
                        </button>

                      </>
                      :
                      <>
                        <hr />
                        {/* <strong>Serviço selecionado:</strong><br /> */}
                        <strong><span>{servicoSelecionado?.nome}</span></strong>
                        <hr />
                        <strong>Valor de 6h às 23h:</strong><br />
                        <span>R$ {ponto?.servicoAtendido?.valor_6_as_23}</span><br />
                        <strong>Valor de 23h às 6h:</strong><br />
                        <span>R$ {ponto?.servicoAtendido.valor_23_as_6}</span><br />                      
                      </>
                    }

                    <hr />

                    <button
                      onClick={() => abrirModal(ponto.id)}
                      style={{
                        marginTop: '10px',
                        padding: '6px 12px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      Solicitar serviço
                    </button>
                  </div>
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
    </>
  );
}

export default MapaAtual;
